export default __webpack_public_path__ + "static/media/brand-6.e1626f3a.jpg";